module.exports = __webpack_public_path__ + "cd51a4f924a345e18a8e893718766c70.png";